import axios from "axios";
import React, { useEffect, useState } from "react";
import banner from "../Assets/Images/faqbanner.jpeg";
import { Link } from "react-router-dom";

function FAQ() {
  const [currentFaq, setCurrentFaq] = useState(0);
  const [datas, setDatas] = useState([]);
  useEffect(() => {
    axios
      .get("https://happiedealz.com/staticpages/faq.json")
      .then((response) => setDatas(response.data))
      .catch((error) => console.error("Error fetching the content:", error));
  }, [])
  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>FAQ</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    FAQ
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="sptb">
        <div class="container">
          <div className="panel-group1">
            {datas.map((item, index) => {
              return item.content ? (
                <div
                  key={item.title}
                  class="panel panel-default mb-4 border p-0"
                >
                  <div class="panel-heading1">
                    <h4 class="panel-title1">
                      <a
                        href="#"
                        class={`accordion-toggle ${currentFaq === index + 1 ? "" : "collapsed"
                          }`}
                        onClick={(e) => {
                          e.preventDefault();
                          setCurrentFaq(currentFaq === index + 1 ? 0 : index + 1);
                        }}
                      >
                        {item.title}
                      </a>
                    </h4>
                  </div>
                  <div
                    class={`panel-collapse active collapse ${currentFaq === index + 1 ? "show" : ""
                      }`}
                  >
                    <div class="panel-body bg-white" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: item.content }}></div>
                  </div>
                </div>
              ) : <h4 className="my-2">{item.title}</h4>;
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default FAQ;
